import cx from 'classnames';
import { Icon } from 'components/@tedui';
import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Accordion as PureAccordion
} from 'components/shared/Accordion';
import { Text } from 'components/typography';
import { useState } from 'react';
import type AccordionProps from './Accordion.props';

interface TEDAccordionProps extends AccordionProps {
  onClick?: () => void;
}

const Accordion = ({
  multiple = false,
  collapsible = true,
  itemStyles = null,
  itemHeaderStyles = '',
  itemHeaderButtonStyles = '',
  itemPanelStyles = null,
  items,
  onClick,
  headerTagName = 'div'
}: TEDAccordionProps) => {
  const [indices, setIndices] = useState<number[]>([]);

  const handleChange = (toggledIndex: number) => {
    if (onClick) {
      onClick();
    }
    if (indices.includes(toggledIndex)) {
      setIndices(indices.filter(currentIndex => currentIndex !== toggledIndex));
    } else if (multiple) {
      setIndices([...indices, toggledIndex].sort());
    } else {
      setIndices([toggledIndex]);
    }
  };

  const itemClassName = itemStyles || 'mb-5';
  const headerClassName = cx(
    'flex w-full items-center justify-between text-left',
    {
      [itemHeaderStyles]: itemHeaderStyles,
      'rounded-sm bg-gray-300 px-5 py-3': !itemHeaderStyles
    }
  );

  const buttonClassName = cx(
    'align-center flex h-4 w-4 items-center justify-center rounded-full lg:h-8 lg:w-8',
    {
      [itemHeaderButtonStyles]: itemHeaderButtonStyles,
      'hover:bg-white': !itemHeaderButtonStyles
    }
  );
  const panelClassName = itemPanelStyles || 'px-5 py-3';

  return (
    <PureAccordion
      multiple={multiple}
      collapsible={collapsible}
      onChange={handleChange}
      className="w-full"
    >
      {items.map(({ title, content }, index) => (
        <AccordionItem key={title} className={itemClassName} index={index}>
          <AccordionButton className="w-full">
            <header className={headerClassName}>
              <Text size="l" tagName={headerTagName}>
                {title}
              </Text>
              <div className={buttonClassName}>
                <Icon
                  iconName={
                    indices.includes(index) ? 'chevron-up' : 'chevron-down'
                  }
                />
              </div>
            </header>
          </AccordionButton>
          <AccordionPanel className={panelClassName}>{content}</AccordionPanel>
        </AccordionItem>
      ))}
    </PureAccordion>
  );
};

export default Accordion;
